import React, { useCallback, useMemo, useState } from "react";

import { gql, useQuery } from "@apollo/client";
import { storefront } from "@app/lib/storefront";

import { MetaobjectField, MetaobjectFieldKey, QueryResponse } from "@app/modules/inline-merch-card/types";

const GET_INLINE_MERCH_CARD_QUERY = gql`
  query GetInlineMerchCard($handle: String!) {
    metaobject(handle: { type: "merch_card", handle: $handle }) {
      handle
      fields {
        key
        value
        reference {
          ... on Metaobject {
            color: field(key: "value") {
              value
            }
          }
          ... on MediaImage {
            image {
              altText
              height
              width
              url
            }
          }
          ... on Video {
            alt
            sources {
              height
              width
              url
            }
          }
        }
      }
    }
  }
`;

export function useInlineMerchCard(handle: string) {
  const { data, error, loading } = useQuery<QueryResponse>(GET_INLINE_MERCH_CARD_QUERY, {
    variables: { handle },
    client: storefront,
  });

  function useFieldValue<Key extends MetaobjectFieldKey>(key: Key) {
    return useMemo(() => {
      if (!data) return undefined;
      return data.metaobject.fields.find((field) => field.key === key) as MetaobjectField<Key>;
    }, [data]);
  }

  return {
    loading,
    metaobject: data?.metaobject,
    useFieldValue,
    error,
  };
}
